export enum PaymentDigitalWalletType {
    None = 0,
    ApplePay = 1,
    GooglePay = 2
}